import { merge } from 'ramda'

import {
  LINK_MEMBER_DEVICES_REQUEST,
  LINK_MEMBER_DEVICES_SUCCESS,
  LINK_MEMBER_DEVICES_FAILURE,
  REMOVE_MEMBER_DEVICES_REQUEST,
  REMOVE_MEMBER_DEVICES_SUCCESS,
  REMOVE_MEMBER_DEVICES_FAILURE,
  UNLINK_MEMBER_DEVICES_REQUEST,
  UNLINK_MEMBER_DEVICES_SUCCESS,
  UNLINK_MEMBER_DEVICES_FAILURE,
  LIST_MEMBER_DEVICES_REQUEST,
  LIST_MEMBER_DEVICES_SUCCESS,
  LIST_MEMBER_DEVICES_FAILURE,
  CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_REQUEST,
  CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_SUCCESS,
  CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_FAILURE,
  SET_LINKING_STATES,
  UPDATE_DEVICE_PROFILE_FAILURE,
  UPDATE_DEVICE_PROFILE_SUCCESS,
  UPDATE_DEVICE_PROFILE_REQUEST,
  GET_THERMOSTAT_CONFIG_REQUEST,
  GET_THERMOSTAT_CONFIG_SUCCESS,
  GET_THERMOSTAT_CONFIG_FAILURE,
} from './constants'

const validVendors = {
  "ECOBEE": {
    "displayName": "Ecobee",
    "hasDevices": false,
  },
  "HONEYWELL": {
    "displayName": "Honeywell TCC",
    "hasDevices": false,
  },
  "RESIDEO": {
    "displayName": "Resideo",
    "hasDevices": false,
  }
}

export const initialState = {
  isLoading: false,
  error: '',
  devices: [],
  linkUrl: '', // retry if popup is not enabled
  isPopupEnabled: null, // controls retry modal when set
  vendors: { ...validVendors }, // array of vendors this member is linked to
  thermostatConfig: [],
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THERMOSTAT_CONFIG_REQUEST:
    case UPDATE_DEVICE_PROFILE_REQUEST:
    case UNLINK_MEMBER_DEVICES_REQUEST:
    case REMOVE_MEMBER_DEVICES_REQUEST:
    case CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_REQUEST:
    case LINK_MEMBER_DEVICES_REQUEST:
    case LIST_MEMBER_DEVICES_REQUEST: {
      return merge(state, { error: '', isLoading: true })
    }
    case UPDATE_DEVICE_PROFILE_SUCCESS:
    case UNLINK_MEMBER_DEVICES_SUCCESS:
    case REMOVE_MEMBER_DEVICES_SUCCESS:
    case LINK_MEMBER_DEVICES_SUCCESS: {
      return merge(state, { isLoading: false, error: '' })
    }
    case SET_LINKING_STATES: {
      const isPopupEnabled =
        action.payload?.isPopupEnabled === undefined
          ? null
          : action.payload?.isPopupEnabled
      const linkUrl = action.payload.linkUrl

      return merge(state, {
        isLoading: false,
        isPopupEnabled: isPopupEnabled,
        linkUrl: linkUrl,
      })
    }
    case LIST_MEMBER_DEVICES_SUCCESS: {
      const buildDeviceVendors = (devices = []) => {
        const found = new Set(devices.map(d => d.vendor));
        return Object.fromEntries(
          Object.entries(validVendors).map(([key, v]) => [
            key,
            { ...v, hasDevices: found.has(key) }
          ])
        );
      };
      return merge(state, {
        devices: action.payload,
        error: '',
        isLoading: false,
        vendors: buildDeviceVendors(action.payload),
      })
    }
    case CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_SUCCESS: {
      return merge(state, { isLoading: false })
    }
    case GET_THERMOSTAT_CONFIG_SUCCESS: {
      return merge(state, { thermostatConfig: action.payload.agreements })
    }
    case UPDATE_DEVICE_PROFILE_FAILURE:
    case UNLINK_MEMBER_DEVICES_FAILURE:
    case REMOVE_MEMBER_DEVICES_FAILURE:
    case CAPTURE_LINK_DEVICES_ACKNOWLEDGEMENT_FAILURE:
    case LINK_MEMBER_DEVICES_FAILURE:
    case GET_THERMOSTAT_CONFIG_FAILURE:
    case LIST_MEMBER_DEVICES_FAILURE: {
      return merge(state, { error: action.payload, isLoading: false })
    }
    default:
      return state
  }
}

export default reducer
